import Blog from "../components/blog/blog"
function Blogpage(){
    return(
        <>
        <Blog/>
        </>
    )
}
export default Blogpage